import { gameApi } from "services/api";
import { navigate } from "gatsby";
import {
  getGamesWithProgress,
  getActiveGame,
  isGameCompleted,
} from "../selectors";
import ModalService from "services/modal";
import Cookies from "js-cookie";
import {
  clusterProfileFormActions,
  selectLayer,
} from "state/clusterprofile/actions/layerConfig";
import { settingFormActions } from "modules/gameSettings";

export const nextStageModal = new ModalService("nextStage");

export function generateGames() {
  return async function (dispatch, getState) {
    const user = getState().game.user;
    const showTutorial = getState().game.showTutorialSteps;
    const { games, id } = await gameApi.post(`users/${user.id}/games`);
    dispatch({
      type: "SET_GAMES",
      games,
      gameId: id,
    });
    Cookies.set("instance", JSON.stringify({ user, gameId: id }));
    !showTutorial && dispatch(startGame());
  };
}

export function fetchGamesProgress() {
  return async function (dispatch, getState) {
    const { userId, gameId } = getState().game;
    const gamesProgress = await gameApi.get(
      `users/${userId}/games/${gameId}/progress`,
    );
    dispatch({
      type: "GET_GAMES_PROGRESS",
      gamesProgress,
    });
  };
}

export function setActiveGame({ uid }) {
  return async function (dispatch) {
    dispatch({
      type: "SET_ACTIVE_GAME",
      uid,
    });
    dispatch({
      type: "SELECT_LAYER",
      selectedLayer: undefined,
    });
  };
}

export function fetchGames(userId) {
  return async function (dispatch) {
    await dispatch(settingFormActions.init({ module: "gameSettings" }));

    return dispatch(generateGames(userId));
  };
}

export function createUser(payload) {
  return async function (dispatch) {
    const user = await gameApi.post("users", payload);
    dispatch({
      type: "CREATE_USER",
      user,
    });
    navigate("/game");
  };
}

export function recordProgress() {
  return async function (dispatch, getState) {
    const currentGame = getActiveGame(getState());
    const layers = getState().forms?.clusterprofile?.data?.layers;
    dispatch({
      type: "RECORD_PROGRESS",
      gameGuid: currentGame.uid,
      progress: layers,
    });
  };
}

export function setScore() {
  return async function (dispatch, getState) {
    navigate("/thank-you");
    const state = getState();
    const userId = state.game.user.id;
    const gameId = state.game.gameId;
    const score = await gameApi.put(
      `users/${userId}/games/${gameId}/progress`,
      { progress: state.forms.clusterprofile.data.layers },
    );
    dispatch({
      type: "SET_SCORE",
      score,
    });
  };
}

export function trackGameProgress() {
  return function (dispatch, getState) {
    const state = getState();
    const minigames = getGamesWithProgress(state);
    const currentGame = getActiveGame(state);
    const stopRecording = isGameCompleted(state);
    const minigame = minigames.find((minigame) => !minigame.isGameCompleted);
    if (!stopRecording && minigame?.uid !== currentGame?.uid) {
      nextStageModal.open().then(() => {
        dispatch(recordProgress());
        dispatch(setActiveGame(minigame));
      });
      return;
    }
    if (stopRecording) {
      dispatch(setScore());
    }
  };
}

export function startGame(updateGameSettings = true) {
  return async function (dispatch, getState) {
    const state = getState();
    const userId = state.game.user.id;
    const gameId = state.game.gameId;
    dispatch({ type: "START_TIMER" });
    dispatch(
      settingFormActions.batchChange({
        updates: {
          music: true,
          sounds: true,
        },
        module: "gameSettings",
      }),
    );
    await gameApi.post(`users/${userId}/games/${gameId}/start`);
  };
}

export function startOver() {
  return async function (dispatch) {
    dispatch(selectLayer(null));
    dispatch(clusterProfileFormActions.init({ module: "clusterprofile" }));
    dispatch({
      type: "RESET_PROGRESS",
    });
    navigate("/game");
  };
}
